import {scrollToElement} from '@/utils/scrollToElement';

const QUIZ_ID = 'quiz';

const urlHasQuiz = (): boolean => window.location.hash === `#${QUIZ_ID}`;

const scrollToQuiz = (): void => scrollToElement(QUIZ_ID, {blockEnd: true});

export {QUIZ_ID, urlHasQuiz, scrollToQuiz};
